export default "__VITE_ASSET__C__pKWi9__"